import Vue from 'vue';
import VueRouter from 'vue-router';
import Meta from 'vue-meta'
import firebase from 'firebase/compat/app';

Vue.use(VueRouter)
Vue.use(Meta)

const router = new VueRouter({
    mode: 'history',
    base: "/",
    routes: [
        {
            path: '/',
            name: 'homepage',
            component: () => import("@/components/pagina/homepage")
        },

        {
            path: '/como-funciona',
            name: 'comofunciona',
            component: () => import("@/components/pagina/comofunciona")
        },
        {
            path: '/fbdelete',
            name: 'eliminarfacebook',
            component: () => import("@/components/pagina/eliminarfacebook"),
            meta: {
                guest: true
            }
        },
        {
            path: '/baresydiscos',
            name: 'baresydiscos',
            component: () => import("@/components/pagina/discosybares.vue")
        },
        {
            path: '/perfil',
            name: 'perfil',
            component: () => import("@/components/clientes/perfil")
        },
        {
            path: '/password',
            name: 'password',
            component: () => import("@/components/clientes/password")
        },
        {
            path: '/fotoperfil',
            name: 'fotoperfil',
            component: () => import("@/components/clientes/fotoperfil")
        },
        {
            path: '/compra',
            name: 'compra',
            component: () => import("@/components/pagina/compra.vue")
        },
        {
            path: '/direccion',
            name: 'direccion',
            component: () => import("@/components/clientes/direccion")
        },
        {
            path: '/tickets',
            name: 'tickets',
            component: () => import("@/components/clientes/tickets")
        },
        {
            path: '/suscripciones',
            name: 'suscripciones',
            component: () => import("@/components/clientes/suscripciones")
        },
        {
            path: '/misqr',
            name: 'misqr',
            component: () => import("@/components/clientes/misqr")
        },
        {
            path: '/qr',
            name: 'qr',
            component: () => import("@/components/clientes/qr")
        },
        {
            path: '/entrada',
            name: 'entrada',
            component: () => import("@/components/clientes/entrada")
        },

        {
            path: '/mislinks',
            name: 'mislinks',
            component: () => import("@/components/promotores/mislinks")
        },
        {
            path: '/carnet',
            name: 'carnet',
            component: () => import("@/components/clientes/carnet")
        },
        {
            path: '/validaqr',
            name: 'validaqr',
            component: () => import("@/components/clientes/validaQR")
        },
        {
            path: '/otorgarqr',
            name: 'otorgarqr',
            component: () => import("@/components/clientes/otorgaqr")
        },
        {
            path: '/tkt/:persona/:codigo',
            name: 'tkt',
            component: () => import("@/components/clientes/tkt")
        },
        {
            path: '/eqr/:codigo',
            name: 'eqr',
            component: () => import("@/components/administrar/clubs/elqr")
        },
        {
            path: '/micarnet/:codigo',
            name: 'micarnet',
            component: () => import("@/components/administrar/clubs/micarnet")
        },
        {
            path: '/:idnegocio/buscar/carnet',
            name: 'buscacarnet',
            component: () => import("@/components/administrar/clubs/buscacarnet")
        },
        {
            path: '/qrinvitado',
            name: 'qrinvitado',
            component: () => import("@/components/clientes/qrinvitado")
        },
        {
            path: '/cliente/crear',
            name: 'creacliente',
            component: () => import("@/components/clientes/creacliente")
        },
        {
            path: '/clientes/ver',
            name: 'clientesman',
            component: () => import("@/components/administrar/superadmin/clientesman")
        },
        {
            path: '/negocios/ver',
            name: 'negociosman',
            component: () => import("@/components/administrar/superadmin/negociosman")
        },
        {
            path: '/politicas',
            name: 'politicas',
            component: () => import("@/components/pagina/politicas"),
            meta: {
                guest: true
            }
        },
        {
            path: '/terminos',
            name: 'terminos',
            component: () => import("@/components/pagina/terminos"),
            meta: {
                guest: true
            }
        },

        {
            path: '/fiesta/:id/lista',
            name: 'fiestalista',
            component: () => import("@/components/pagina/fiestalista"),
            meta: {
                guest: true
            }
        },
        {
            path: '/puerta/login',
            name: 'logpuerta',
            component: () => import("@/components/puerta/logpuerta"),
            meta: {
                guest: true
            }
        },
        {
            path: '/puerta/ver',
            name: 'verpuerta',
            component: () => import("@/components/puerta/verpuerta"),
            meta: {
                guest: true
            }
        },
        {
            path: '/puerta/cliente',
            name: 'clientepuerta',
            component: () => import("@/components/puerta/clientepuerta"),
            meta: {
                guest: true
            }
        },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import("@/components/administrar/Dashboard"),
        meta: {
            requiresAuth: true
        }
    },
        {
            path: '/dashsuperadmin',
            name: 'DashSuperAdmin',
            component: () => import("@/components/administrar/superadmin/DashSuperAdmin"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/promotor/:idnegocio/listas',
            name: 'ListasPromotor',
            component: () => import("@/components/promotores/listaspromotor"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/puerta/:idnegocio/codigos',
            name: 'CodigoPuerta',
            component: () => import("@/components/administrar/clubs/CodigoPuerta"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/promotor/:idnegocio/nueva',
            name: 'NuevaListaPromotor',
            component: () => import("@/components/promotores/nuevalistapromotor"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/promotor/:idnegocio/codigos',
            name: 'generacodigospr',
            component: () => import("@/components/promotores/generacodigospr"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/:idnegocio/inscripcion',
            name: 'inscripcion',
            component: () => import("@/components/administrar/clubs/forms/inscripcion")
        },

        {
            path: '/:idnegocio/membresia',
            name: 'membresia',
            component: () => import("@/components/administrar/clubs/forms/membresia")
        },

        {
            path: '/membresia/omen',
            name: 'membresiaomen',
            component: () => import("@/components/formularios/membresiaomen")
        },
        {
            path: '/:idnegocio/compra',
            name: 'compramembresia',
            component: () => import("@/components/administrar/clubs/forms/compra")
        },
        {
            path: '/juegos/Ruleta/:tag',
            name: 'ruleta',
            component: () => import("@/components/juegos/Ruleta")
        },
        {
            path: '/lg/home',
            name: 'lgportada',
            component: () => import("@/components/externos/lgportada")
        },
        {
            path: '/lg/form',
            name: 'lgform',
            component: () => import("@/components/externos/lgformulario")
        },
        {
            path: '/juegos/Ruleta2/:tag',
            name: 'ruleta2',
            component: () => import("@/components/juegos/Ruleta2")
        },
        {
            path: '/juegos/SlotMachine/:tag',
            name: 'slotmachine',
            component: () => import("@/components/juegos/SlotMachine")
        },
        {
            path: '/juegos/MemoriaCartas/:tag',
            name: 'memoriacartas',
            component: () => import("@/components/juegos/MemoriaCartas")
        },
        {
            path: '/:idnegocio/participa',
            name: 'participacion',
            component: () => import("@/components/administrar/clubs/forms/participa")
        },
        {
            path: '/:idnegocio/codigoqr',
            name: 'codigoqr',
            component: () => import("@/components/administrar/clubs/clubQR")
        },

        {
            path: '/:idnegocio/contactos',
            name: 'contactocl',
            component: () => import("@/components/administrar/clubs/contactoscl")
        },
        {
            path: '/fqr/:codigo',
            name: 'fiestaqr',
            component: () => import("@/components/pagina/fiestaqr")
        },
        {
            path: '/mall',
            name: 'mall',
            component: () => import("@/components/pagina/mall")
        },
        {
            path: '/:tagevento/inscribete',
            name: 'eventosinscripcion',
            component: () => import("@/components/administrar/eventos/eventosinscripcion")
        },
        {
            path: '/:tagevento/formulario',
            name: 'eventosformulario',
            component: () => import("@/components/administrar/eventos/formulario")
        },
        {
            path: '/johnniewalkerblonde',
            name: 'johnniewalkerblonde',
            component: () => import("@/components/formularios/johnniewalkerblonde")
        },
        {
            path: '/lg/experiencia',
            name: 'lgexperiencia',
            component: () => import("@/components/externos/lgexperiencia.vue")
        },
        {
            path: '/lg/cocina',
            name: 'lgcocina',
            component: () => import("@/components/externos/lgcocina.vue")
        },
        {
            path: '/lg/dormitorio',
            name: 'lgdormitorio',
            component: () => import("@/components/externos/lgdormitorio.vue")
        },
        {
            path: '/lg/yesenia',
            name: 'lgyesenia',
            component: () => import("@/components/externos/lgyesenia.vue")
        },
        {
            path: '/lg/sala',
            name: 'lgsala',
            component: () => import("@/components/externos/lgsala.vue")
        },
        {
            path: '/sgsfest',
            name: 'sgsfest',
            component: () => import("@/components/formularios/sgsfest")
        },
        {
            path: '/chivasmiami',
            name: 'ChivasMiami',
            component: () => import("@/components/formularios/chivasmiami")
        },
        {
            path: '/charanga',
            name: 'charanga',
            component: () => import("@/components/formularios/charanga")
        },

        {
            path: '/karenydaniel',
            name: 'karenydaniel',
            component: () => import("@/components/pagina/karenydaniel")
        },
        {
            path: '/vuse',
            name: 'vuse',
            component: () => import("@/components/formularios/vuse")
        },
        {
            path: '/vuse-encuesta',
            name: 'vuseencuesta',
            component: () => import("@/components/formularios/vuse-enc")
        },
        {
            path: '/vuse-beerpong',
            name: 'vusebeerpong',
            component: () => import("@/components/formularios/vuse-beerpong")
        },
        {
            path: '/ultra-internet',
            name: 'ultraInternet',
            component: () => import("@/components/formularios/ultra-internet")
        },
        {
            path: '/win-negocios',
            name: 'winNegocios',
            component: () => import("@/components/formularios/win-negocios.vue")
        },
        {
            path: '/summerdrink',
            name: 'summerdrink',
            component: () => import("@/components/formularios/summerdrink")
        },
        {
            path: '/:tagevento/sorteo',
            name: 'eventossorteo',
            component: () => import("@/components/administrar/eventos/sorteos")
        },
        {
            path: '/negocios/sorteo',
            name: 'negociossorteo',
            component: () => import("@/components/sorteos/versorteo")
        },
        {
            path: '/negocios/sorteo/:tag',
            name: 'negociossorteotag',
            component: () => import("@/components/sorteos/fiestasorteo")
        },
        {
            path: '/negocios/:tag/sortear',
            name: 'fiestasortear',
            component: () => import("@/components/sorteos/sortear")
        },
        {
            path: '/:tagevento/catalogo/:number',
            name: 'catalogoformulario',
            component: () => import("@/components/administrar/eventos/datos")
        },
        {
            path: '/:tagevento/catalogos',
            name: 'catalogosformulario',
            component: () => import("@/components/administrar/eventos/catalogos")
        },
        {
            path: '/qrevento',
            name: 'QRevento',
            component: () => import("@/components/administrar/eventos/LeeQREv")
        },
        {
            path: '/lista/:md5promo',
            name: 'lista',
            component: () => import("@/components/listapr/lista")
        },
        {
            path: '/lst/:md5promo',
            name: 'lst',
            component: () => import("@/components/listapr/lst")
        },
        {
            path: '/lista/reserva/:codigo',
            name: 'listareserva',
            component: () => import("@/components/listapr/listareserva")
        },
        {
            path: '/l/:md5promo',
            name: 'listapromotores',
            component: () => import("@/components/listapr/promot")
        },
        {
            path: '/lista/email/:md5promo',
            name: 'listamail',
            component: () => import("@/components/listapr/listamail")
        },
        {
            path: '/listaqr/:md5promo',
            name: 'listaqr',
            component: () => import("@/components/listapr/lst")
        },
        {
            path: '/mislistas/:md5promo',
            name: 'mislistas',
            component: () => import("@/components/listapr/lst")
        },
    {
        path: '/:idnegocio/fiestas',
        name: 'Fiestas',
        component: () => import("@/components/administrar/clubs/Fiestas"),
        meta: {
            requiresAuth: true
        }
    },
        {
            path: '/:idnegocio/disenios/membresia/:idhash',
            name: 'DisenioMembresia',
            component: () => import("@/components/administrar/clubs/disenios/membresia"),
            meta: {
                requiresAuth: true
            }
        },

        {
            path: '/:idnegocio/disenios/formularios',
            name: 'DisenioFormularios',
            component: () => import("@/components/administrar/clubs/disenios/formularios"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/:idnegocio/negocio/fiestas',
            name: 'FiestasNegocios',
            component: () => import("@/components/administrar/superadmin/fiestasneg"),
            meta: {
                requiresAuth: true
            }
        }
    ,
    {
        path: '/zonas/:idnegocio',
        name: 'Zonas',
        component: () => import("@/components/administrar/clubs/Zonas"),
        meta: {
            requiresAuth: true
        }
    },
        {
            path: '/acto/:tag',
            name: 'acto',
            component: () => import("@/components/pagina/acto")
        },
        {
            path: '/carro',
            name: 'carro',
            component: () => import("@/components/pagina/carro")
        },
        {
            path: '/eventos/zonas',
            name: 'ZonaEvento',
            component: () => import("@/components/administrar/eventos/ZonaEvento"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/eventos/entradas',
            name: 'TicketEvento',
            component: () => import("@/components/administrar/eventos/TicketEvento"),
            meta: {
                requiresAuth: true
            }
        },
    {
        path: '/:idnegocio/mesas',
        name: 'Mesas',
        component: () => import("@/components/administrar/clubs/Mesas"),
        meta: {
            requiresAuth: true
        }
    },
        {
            path: '/:idnegocio/mapamesas',
            name: 'MapaMesas',
            component: () => import("@/components/administrar/clubs/MapaMesas"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/:idnegocio/configuracion',
            name: 'Configuracion',
            component: () => import("@/components/administrar/clubs/Configuracion"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/:idnegocio/usuarios',
            name: 'Usuarios',
            component: () => import("@/components/administrar/clubs/Usuarios"),
            meta: {
                requiresAuth: true
            }
        },
    {
        path: '/:idnegocio/separacion',
        name: 'Separacion',
        component: () => import("@/components/administrar/clubs/Separacion"),
        meta: {
            requiresAuth: true
        }
    },
        {
            path: '/:idnegocio/reserva/fiesta',
            name: 'ReservaFiesta',
            component: () => import("@/components/administrar/clubs/ReservaFiesta"),
            meta: {
                requiresAuth: true
            }
        },
    {
        path: '/:idnegocio/listaspromo',
        name: 'Listaspromo',
        component: () => import("@/components/administrar/clubs/Listaspromo"),
        meta: {
            requiresAuth: true
        }
    },
        {
            path: '/:idnegocio/marcarlista',
            name: 'Listasmarcar',
            component: () => import("@/components/administrar/clubs/Listasmarcar"),
            meta: {
                requiresAuth: true
            }
        },
    {
        path: '/:idreserva/listasreserva',
        name: 'ListasR',
        component: () => import("@/components/administrar/clubs/Listareserva"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:idnegocio/socios',
        name: 'Socios',
        component: () => import("@/components/administrar/clubs/Socios"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/:idnegocio/promotores',
        name: 'Promotor',
        component: () => import("@/components/administrar/clubs/Promotor"),
        meta: {
            requiresAuth: true
        }
    },
        {
            path: '/:idnegocio/puerta',
            name: 'Puerta',
            component: () => import("@/components/administrar/clubs/Puerta"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/:idnegocio/cumples',
            name: 'Cumples',
            component: () => import("@/components/administrar/clubs/Cumples"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/:idnegocio/asistencia/ranking',
            name: 'RankingAsistencia',
            component: () => import("@/components/administrar/clubs/RankingAsistencias"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/:idnegocio/asistencia/lista',
            name: 'Asistencia',
            component: () => import("@/components/administrar/clubs/Asistentes"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/:idnegocio/temporadas',
            name: 'Temporadas',
            component: () => import("@/components/administrar/clubs/Temporadas"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/:idnegocio/tipolistas',
            name: 'TipoListas',
            component: () => import("@/components/administrar/clubs/TipoLista"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/:idnegocio/tipocarnets',
            name: 'TipoCarnets',
            component: () => import("@/components/administrar/clubs/TipoCarnet"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/:idnegocio/generacodigo',
            name: 'GeneraCodigo',
            component: () => import("@/components/administrar/clubs/GeneraCodigos"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/:idnegocio/generalista',
            name: 'GeneraLista',
            component: () => import("@/components/administrar/clubs/GeneraLista"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/socio/ver/:idpersona',
            name: 'VerSocio',
            component: () => import("@/components/administrar/clubs/VerSocio"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/eventos/lista',
            name: 'Eventos',
            component: () => import("@/components/administrar/eventos/Eventos"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/juegos/lista',
            name: 'Juegos',
            component: () => import("@/components/administrar/juegos/Juegos"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/juegos/premios/ruleta/:idjuego',
            name: 'PremiosRuleta',
            component: () => import("@/components/administrar/juegos/PremiosRuleta"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/eventos/reporte/contactos',
            name: 'ReporteContactos',
            component: () => import("@/components/administrar/eventos/ReporteContactos"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/eventos/inscritos',
            name: 'Inscritos',
            component: () => import("@/components/administrar/eventos/Inscritos"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/juegos/inscritos',
            name: 'JuegosInscritos',
            component: () => import("@/components/administrar/juegos/JuegosInscritos"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/crea/evento/primero',
            name: 'CreaPaso1',
            component: () => import("@/components/administrar/eventos/CreaPaso1"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/crea/evento/segundo',
            name: 'CreaPaso2',
            component: () => import("@/components/administrar/eventos/CreaPaso2"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/crea/evento/tercero',
            name: 'CreaPaso3',
            component: () => import("@/components/administrar/eventos/CreaPaso3"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/crea/juego',
            name: 'CreaPasoJuego',
            component: () => import("@/components/administrar/juegos/CreaJuego.vue"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/eventos/contactos',
            name: 'Contactos',
            component: () => import("@/components/administrar/eventos/Contactos"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '*',
            name: 'error',
            component: () => import("@/components/error/notfound")
        }
]
});

router.beforeEach((to,from,next) => {
const currentUser = firebase.auth().currentUser
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    if(requiresAuth && !currentUser) next('/')
    else next()
    });
export default router
